import { render, staticRenderFns } from "./v-side.vue?vue&type=template&id=c23b390a&scoped=true"
import script from "./v-side.vue?vue&type=script&lang=js"
export * from "./v-side.vue?vue&type=script&lang=js"
import style0 from "./v-side.vue?vue&type=style&index=0&id=c23b390a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23b390a",
  null
  
)

export default component.exports